import { call, take, all, put } from 'redux-saga/effects'
import { googleUserSignIn } from 'helpers/googleDrive'
import actionTypes from 'redux/actions/actionTypes'
import googleDriveActions from 'redux/actions/googleDriveActions'
import formatError from './error_formatter'

function *waitForUserSignIn() {
	const action = yield take([
		actionTypes.GOOGLE_SLIDES_AUTHORIZE_USER_CANCEL,
		actionTypes.GOOGLE_SLIDES_AUTHORIZE_USER_SUCCESS,
	])

	if (action.type === actionTypes.GOOGLE_SLIDES_AUTHORIZE_USER_CANCEL) {
		const error = {
			serverError: action.error,
		}
		throw new Error(error)
	}
}

function *googleSignIn() {
	try {
		yield call(googleUserSignIn)

		yield put(googleDriveActions.googleAuthorizeUserSuccess())
	} catch (error) {
		const serverError = formatError(error)
		yield put(googleDriveActions.googleAuthorizeUserFailed(serverError))
	}
}

function *googleAuthorizeUser() {
	yield all([call(googleSignIn), call(waitForUserSignIn)])
}

export default googleAuthorizeUser
